import React from 'react'
import ReduxToastr from 'react-redux-toastr'
import 'modules/react-redux-toastr/lib/css/react-redux-toastr.min.css'

export default props => (
    <ReduxToastr 
        timeOut={3000}
        newestOnTop={false}
        preventDuplicates={true}
        position='top-center'
        transitionIn='fadeIn'
        transitionOut='fadeOut'
        progressBar />
)


// WEBPACK FOOTER //
// ./src/common/msg/messages.jsx